import { useEffect, useState } from 'react'
import { inflightBadges, type InflightBadges as Badges, type InflightState } from '../api/inflight'
import { CHANGED_EVENT, TABS, openInflight } from './InflightDrawer'

/**
 * Insignele din subsol - `_layout/commands_badges.php` + `public/js/footer_commands.js`.
 *
 * Numerele vin de la `GET /api/v2/sidebar/inflight` din 30 in 30 de secunde,
 * si mai devreme dupa un Clear/Resend din fereastra (`od:inflight-changed`)
 * sau dupa ce s-a trimis o comanda (`od:inflight-sent`). O insigna pe zero
 * primeste `od-inflight-zero` (stinsa, ca in portal). Clicul deschide
 * fereastra pe fila ei.
 */
export const EVERY_MS = 30_000
export const SENT_EVENT = 'od:inflight-sent'

const CLASSES: Record<InflightState, string> = {
  running: 'badge-warning',
  waiting: 'badge-primary',
  failed: 'badge-danger',
  succeeded: 'badge-success',
  changes: 'badge-info',
  tickets: 'badge-default',
}

/**
 * Iconita fara `fa-spin`, pe TOKEN, nu pe subsir: `' fa-spin'` se gaseste
 * intai INAUNTRUL lui ` fa-spinner`, si `replace` lasa `fasner fa-spin` -
 * nici `fas`, nici glifa, deci pe zero insigna Running ramanea fara iconita
 * (26.9.14.12). Portalul face `toggleClass('fa-spin')`, care lucreaza pe clase.
 */
export function still(icon: string): string {
  return icon
    .split(' ')
    .filter((c) => c !== 'fa-spin')
    .join(' ')
}

export function InflightBadges() {
  const [counts, setCounts] = useState<Badges | null>(null)

  useEffect(() => {
    let alive = true
    const ask = (): void => {
      void inflightBadges('mine')
        .then((reply) => {
          if (alive) setCounts(reply)
        })
        .catch(() => undefined)
    }
    ask()
    const timer = window.setInterval(ask, EVERY_MS)
    /* Dupa ce s-a trimis o comanda, masina o ia in cateva secunde: se
       intreaba de doua ori, ca in `footer_commands.js` (AFTER_SEND). */
    const onSent = (): void => {
      window.setTimeout(ask, 2000)
      window.setTimeout(ask, 8000)
    }
    window.addEventListener(CHANGED_EVENT, ask)
    window.addEventListener(SENT_EVENT, onSent)
    return () => {
      alive = false
      window.clearInterval(timer)
      window.removeEventListener(CHANGED_EVENT, ask)
      window.removeEventListener(SENT_EVENT, onSent)
    }
  }, [])

  return (
    <div id="od-inflight" data-scope="mine" data-can-clear-any={counts?.can_clear_any ? '1' : '0'}>
      {TABS.map((b) => {
        const n = counts ? Number(counts[b.state] ?? 0) : 0
        return (
          <span
            key={b.state}
            data-state={b.state}
            data-toggle="tooltip"
            title={b.title}
            className={`badge ${CLASSES[b.state]} badge-transparent pointer me-1${n === 0 ? ' od-inflight-zero' : ''}${b.state === 'failed' && n > 0 ? ' pulse' : ''}`}
            onClick={() => openInflight(b.state)}
          >
            {/* Rosul pulseaza si sageata se invarte NUMAI cand chiar e ceva
                (`footer_commands.js`): o bara care se misca degeaba invata
                omul sa n-o mai vada. */}
            <span id={`od-inflight-${b.state}`}>{n > 999 ? '999+' : String(n)}</span>{' '}
            <i className={n > 0 ? b.icon : still(b.icon)}></i>
          </span>
        )
      })}
    </div>
  )
}
